import { useMutation, useQueryClient } from "react-query";
import { useState } from "react";
import axios from "../apis/axios";
import Cookies from "universal-cookie";
import { TOKEN_NAME, IDENTITY } from "../config";
import { decode } from "base-64";
const cookies = new Cookies();


function usePostData({ url, refreshUrl,onSuccess }) {
    const queryClient = useQueryClient()
    const setDataToServer = useMutation((data) => setUsers(data), {
        onError: (err) => {},
        onSuccess: (data) => {
            queryClient.invalidateQueries(refreshUrl)
            onSuccess(data)
        }
    })
    const setUsers = async (getFormData) => {
        let TOKEN = cookies.get(TOKEN_NAME);
        let fd = new FormData()
        fd.append('token', decode(TOKEN))
        fd.append('identity', IDENTITY)
        for (var key in getFormData) {
            if (Array.isArray(getFormData[key])) {
                fd.append(key, JSON.stringify(getFormData[key]));
            } else {
                fd.append(key, getFormData[key]);
            }
        }
        const response = await axios({
            method: "POST",
            data: fd,
            url: url,
            // headers: { Authorization: TOKEN ? `Bearer ${TOKEN}` : '', }
        })
        return response.data
    }
    return { setDataToServer }

}

export default usePostData